<template>
  <div class="option-container">
    <h4><span v-if="model.option.name">{{model.option.name}}</span></h4>
    <ul>
      <li><span v-if="model.start_date">Date de début : {{model.start_date | moment-date-time }}</span></li>
      <li><span v-if="model.end_date">Date de fin : {{model.end_date | moment-date-time }}</span></li>
    </ul>
  </div>
</template>
<script>

export default {
  name:"ModelOptionCreation",

  props:["model"],

  components:{

  }

}
</script>

<style scoped>

.option-container {
  border: solid 1px lightgray;
  padding: 0 15px;
  width: 100%;
  background-color: white;
}

</style>



// WEBPACK FOOTER //
// client/components/Demands/ModelOptionCreation.vue